import React from 'react';
import { FaLinkedin, FaWhatsapp, FaGithub } from 'react-icons/fa';

// ContactIcon component with cinematic, responsive, and dynamic appearance
// Icons are centered, with increased color intensity and hover effects
const ContactIcon = () => {
  const icons = [
    { id: 1, href: 'https://wa.me/+923477990356', icon: <FaWhatsapp />, label: 'WhatsApp', color: 'hover:text-green-500' },
    { id: 2, href: 'https://www.linkedin.com/in/ali-hassan-salman-49420a332/', icon: <FaLinkedin />, label: 'LinkedIn', color: 'hover:text-blue-500' },
    { id: 3, href: 'https://github.com/alihassan-coder', icon: <FaGithub />, label: 'GitHub', color: 'hover:text-gray-500' },
  ];

  return (
    <div className="flex justify-center items-center space-x-6 py-6 flex-wrap bg-transparent">
      {icons.map(({ id, href, icon, label, color }) => (
        <a
          key={id}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className={`group border border-gray-500 rounded-full p-4 text-gray-300 transition-all duration-500 transform hover:scale-110 hover:border-white shadow-lg hover:shadow-gray-800/50 ${color}`}
          aria-label={label}
        >
          <div className="w-16 h-16 flex justify-center items-center text-4xl group-hover:rotate-12 transition-transform duration-300">
            {icon}
          </div>
        </a>
      ))}
    </div>
  );
};

export default ContactIcon;
